export default __webpack_public_path__ + "static/media/badge_normal.552304bd.svg";